/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Action/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import ActionButton from './ActionButton/index'
import React from 'react'
import SecondaryAction from './SecondaryAction/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Action({
  children,
  viewPath = "/DesignSystem/TasksViewForm/Content/Content/Actions/OldAction/Action"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let actionItemIndexValueData = fromData.useDataValue({ viewPath,
context: 'action_item',
path: 'index',
})
let constantData = 1
let aggregateData = fromAggregate.add(actionItemIndexValueData, constantData)
let dtTypographyFontsizeM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.m'
        })
let actionTypeValueData = fromData.useDataFormat({ viewPath,
context: 'action',
path: 'type',
format: fromHelpers.getActionTitle,
})
  return (<React.Fragment
>
<div
  data-testid="Action.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-2jfVQF': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Action.Vertical"
  data-view-path={viewPath}
 style={{'--bc-2-2jfVQF': dtColorsNeutral200,'--btlr-3-2jfVQF': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--btrr-4-2jfVQF': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--bbrr-5-2jfVQF': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--bblr-6-2jfVQF': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="action_item.index"
 data={1}
 aggregate="/Data/aggregate.js add"
 text={aggregateData}
 fontSize={dtTypographyFontsizeM}
 weight="medium"
/>
</div>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="action.type"
 format="helpers.js getActionTitle"
 text={actionTypeValueData}
/>
<SecondaryAction
  viewPath={`${viewPath}/SecondaryAction`}
/>
<ActionButton
  viewPath={`${viewPath}/ActionButton`}
/>
</div>
{children}
</React.Fragment>)
}